import { render, staticRenderFns } from "./CantReachServer.vue?vue&type=template&id=94a64f9e&"
import script from "./CantReachServer.vue?vue&type=script&lang=js&"
export * from "./CantReachServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports